import { actions } from '@store/ducks/auth';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteChildrenProps, useRouteMatch } from 'react-router-dom';
import TStore from 'types/store';
import AuthLayout from '../components/auth-layout';
import { StepCode, StepForm, StepLanding, StepPatient, StepRole, StepSuccess } from './components';
import RegDevTools from './components/reg-dev-tools';
import { STEPS, TPAthParams } from './registration.types';
import { mapStepPathToId, STEP_BG } from './registration.utils';

const Registration: React.FC<RouteChildrenProps> = () => {
  const step = useSelector((state: TStore) => state.auth.currentRegStep);
  const { params } = useRouteMatch<TPAthParams>();
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(actions.setCurrentRegStep(mapStepPathToId(params.step)));
  }, []);

  const content = useMemo(() => {
    switch (step) {
      case STEPS.LANDING:
        return <StepLanding />;
      case STEPS.REG_FORM:
        return <StepForm />;
      case STEPS.CODE:
        return <StepCode />;
      case STEPS.ROLE:
        return <StepRole />;
      case STEPS.SUCCESS:
        return <StepSuccess />;
      case STEPS.PATIENT_ONLY:
        return <StepPatient />;
      default:
        return null;
    }
  }, [step]);

  return (
    <AuthLayout step={step} backgroundImage={STEP_BG[step]}>
      {content}
      <RegDevTools />
    </AuthLayout>
  );
};

export default React.memo(Registration);
